import React from 'react';
import { connect } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
    CONFIRMATION,
    notApplicable,
    REVIEW,
    ExperienceRewardsTermsLink,
    GM_REWARDS_DEALERS_LINK,
} from '../../shared/Constants/SharedConstants';
import { AuthenticatedFlow, EditAppointmentFlow } from '../../shared/RoutingFlow/FlowComponentsConstants';

const Disclaimer = (props) => {
    const {
        countryOptions,
        vTranslations,
        active,
        enrollMyRewardsError,
        softEnroll,
        flowSource,
        headerNav,
        useMyRewardsIndicator,
        usePoints,
        isBannerDisplayed,
        redeemEligible,
        country,
        cardholder,
        showUseMyRewards,
    } = props;

    const consent = () => {
        const showPrivacyDetails = countryOptions.SHOW_PRIVACY_DETAILS;
        const showPrivacyDetailsModal = countryOptions.SHOW_PRIVACY_DETAILS_MODAL;
        if (showPrivacyDetails === 'true' && showPrivacyDetailsModal === 'true') {
            return (
                <div className="view-privacy-policy">
                    <span
                        id="btnPrivacy"
                        className="contact-disclaimer-label"
                        dangerouslySetInnerHTML={{
                            __html: `${vTranslations.CONSENT_PART_ONE} ${vTranslations.CONSENT_LINK} ${vTranslations.CONSENT_PART_TWO}`,
                        }}
                    />
                </div>
            );
        }
        if (showPrivacyDetails === 'true' && showPrivacyDetailsModal === 'false') {
            return (
                <span
                    id="btnPrivacy"
                    className="contact-disclaimer-label"
                    dangerouslySetInnerHTML={{
                        __html:
                            vTranslations.CONTACT_CONSENT === undefined
                                ? `${vTranslations.CONSENT_PART_ONE} ${vTranslations.CONSENT_LINK} ${vTranslations.CONSENT_PART_TWO}`
                                : vTranslations.CONTACT_CONSENT,
                    }}
                />
            );
        }
        return null;
    };

    const showPrivacySection =
        countryOptions.SHOW_PRIVACY_DETAILS === 'true' && headerNav === REVIEW;
    const showRewardsDisclaimer = countryOptions.GET_LOYALTY === 'true' && showUseMyRewards;

    const rewardsLink = (
        <a href={ExperienceRewardsTermsLink} target="_blank" rel="noreferrer">
            {ExperienceRewardsTermsLink.toString().replace('https://', '')}
        </a>
    );

    const rewardsDealersLink = (
        <a href={GM_REWARDS_DEALERS_LINK} target="_blank" rel="noreferrer">
            {GM_REWARDS_DEALERS_LINK.toString().replace('https://', '')}
        </a>
    );

    if (showPrivacySection || showRewardsDisclaimer) {
        const isRewardsFooterContext =
            (active &&
                usePoints &&
                headerNav === CONFIRMATION) ||
            (active &&
                headerNav === REVIEW &&
                useMyRewardsIndicator !== notApplicable &&
                redeemEligible) ||
            (flowSource === EditAppointmentFlow &&
                useMyRewardsIndicator !== notApplicable) ||
            (headerNav === CONFIRMATION &&
                flowSource === AuthenticatedFlow &&
                active === undefined &&
                enrollMyRewardsError === undefined) ||
            (headerNav === CONFIRMATION &&
                flowSource !== AuthenticatedFlow &&
                active === undefined &&
                useMyRewardsIndicator === notApplicable);

        const isCreditCardEligible = Boolean(!cardholder && active && !softEnroll && headerNav === CONFIRMATION);
        const showDisclaimerPartOne = isRewardsFooterContext;
        const showDisclaimerRedeem = isRewardsFooterContext || isCreditCardEligible;
        const showDisclaimerEligibility = isRewardsFooterContext && softEnroll;
        const hasPrivacyConsent = headerNav === REVIEW && country !== 'US' && consent() !== null;
        const hasRewardsContent = showRewardsDisclaimer && (showDisclaimerPartOne || showDisclaimerRedeem || showDisclaimerEligibility);
    

        if (!hasPrivacyConsent && !hasRewardsContent) {
            return null;
        }

        return (
            <div className="submit-appointment-disclaimer paper">
                <div className="submit-appointment-disclaimer-title headline3"></div>
                <div className="submit-appointment-disclaimer-statement">
                    {hasPrivacyConsent && consent()}
                    {showRewardsDisclaimer && (
                        <>
                            {countryOptions.GET_LOYALTY_CARD_FOOTER === 'true' ? (
                                <>
                                    {showDisclaimerPartOne ? (
                                        <>
                                            <p>
                                                {softEnroll
                                                    ? vTranslations.DISCLAIMER_PART_ONE_NON_MEMBER
                                                    : vTranslations.DISCLAIMER_PART_ONE}{' '}
                                                {rewardsLink} {vTranslations.DISCLAIMER_PART_TWO}
                                            </p>
                                        </>
                                    ) : null}

                                    {showDisclaimerRedeem ? (
                                        <>
                                            <p>
                                                {vTranslations.DISCLAIMER_REDEEM_PART1}{' '}
                                                {rewardsDealersLink}{' '}
                                                {vTranslations.DISCLAIMER_REDEEM_PART2}
                                            </p>
                                        </>
                                    ) : null}

                                    {showDisclaimerEligibility ? (
                                        <>
                                            <p>
                                                {vTranslations.DISCLAIMER_ELIGIBILITY ||
                                                    'DISCLAIMER_ELIGIBILITY'}
                                            </p>
                                        </>
                                    ) : null}
                                </>
                            ) : (
                                <>
                                    {isBannerDisplayed ||
                                    useMyRewardsIndicator !== notApplicable ? (
                                        <p>
                                            {vTranslations.DISCLAIMER_PART_ONE} {rewardsLink}{' '}
                                            {vTranslations.DISCLAIMER_PART_TWO}
                                        </p>
                                    ) : null}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }

    return null;
};

const mapStateToProps = (state) => ({
    countryOptions: state.countryOptionsReducer.countryOptions,
    brands: state.prefillReducer.dealerSummaryObject.dealershipSummary.brands,
    vTranslations: state.countryOptionsReducer.translations,
    active: state.myRewardsReducer.active,
    enrollRewards: state.myRewardsReducer.enrollRewards,
    enrollMyRewardsError: state.myRewardsReducer.enrollMyRewardsError,
    softEnroll: state.myRewardsReducer.softEnroll,
    preferredBrand: state.myRewardsReducer.preferredBrand,
    themeMake: state.prefillReducer.themeMake,
    make: state.prefillReducer.make,
    flowSource: state.prefillReducer.flowSource,
    headerNav: state.headReducer.headerNavigation,
    showErrorMessage: state.myRewardsReducer.showError,
    useMyRewardsIndicator: state.prefillReducer.useMyRewardsIndicator,
    usePoints: state.myRewardsReducer.usePoints,
    isBannerDisplayed: state.myRewardsReducer.isBannerDisplayed,
    redeemEligible: state.myRewardsReducer.redeemEligible,
    country: state.prefillReducer.country,
    cardholder: state.myRewardsReducer.cardholder,
});

const ConnectedDisclaimer = connect(mapStateToProps)(Disclaimer);

const DisclaimerWithFlags = (props) => {
    const { hideRewardsByVendor } = useFlags();

    return <ConnectedDisclaimer {...props} showUseMyRewards={hideRewardsByVendor !== true} />;
};

export default DisclaimerWithFlags;
